/* unplugin-vue-components disabled */import script from "./ChatArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatArea.vue?vue&type=script&setup=true&lang=js"

import "./ChatArea.vue?vue&type=style&index=0&id=0b18107e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b18107e"]])

export default __exports__